import { NewsletterId } from 'modules/newsletters/single/types/newsletter-interface'

export const getSplitTestNewsletterStatisticsUrl = (newsletterId: NewsletterId) =>
  `/mailing/split-test/${newsletterId}/statistics`
